export const degreesToRadians = degrees => {
  const pi = Math.PI;
  return degrees * (pi / 180);
};
